import AddressApiRequest from "./AddressApiRequest";
import { METHOD } from "../Constants";
import { GET_ADDRESS_INSTANCE_KEY_URL } from "../ApiUrls";
import { formURL } from "Utils/CommonUtilities";

export default class CreateAddressInstanceKey extends AddressApiRequest {
  method = METHOD.HTTP.GET;

  url = GET_ADDRESS_INSTANCE_KEY_URL;

  body = {};
  headers = {};
  constructor() {
    super();
    this.headers["Authorization"] =
      "Basic RG94SW5jNDI3OTpxR0Y2N1w3Wys2d1EyQj9rd31lNl9wRFU=";
  }

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return this.url;
  };

  getBody = () => {
    return this.body;
  };

  getHeader = () => {
    return this.headers;
  };
}
